export class IRankingRepository {
  async getSupplementsRanking(params) {
    throw new Error('Method must be implemented');
  }

  async getMedicationsRanking(params) {
    throw new Error('Method must be implemented');
  }

  async getProductRanking(params) {
    throw new Error('Method must be implemented');
  }

  async getProductTrend(productId, params) {
    throw new Error('Method must be implemented');
  }

  async getSearchTrend(params) {
    throw new Error('Method must be implemented');
  }

  async getHighlights() {
    throw new Error('Method must be implemented');
  }

  async getProductDetail(productId) {
    throw new Error('Method must be implemented');
  }
}
